function openGuiaTallas() {
  const modal = document.getElementById("guiaModal");
  if (modal) {
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }
}

function closeGuiaTallas() {
  const modal = document.getElementById("guiaModal");
  if (modal) {
    modal.style.display = "none";
    document.body.style.overflow = "auto";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("guiaModal");
  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeGuiaTallas();
      }
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeGuiaTallas();
    }
  });
});
